import { useState } from "react";
import { Col, Row, Image, Typography, List, Flex, Avatar } from "antd"
import { ABOUT_KARNCY, GEN_TEXT } from "../../constants/constants"
import Logo from "../../assets/images/auth-logo.png";
import CoinsFly from "../../assets/images/auth-coins-fly.png";
import SemiRing from "../../assets/images/auth-bg-semi-ring.png";
import TermsPdf from "../../assets/docs/TermsAndConditions.pdf"
import PrivacyPdf from "../../assets/docs/PrivacyPolicies.pdf"
import CustomModal from "../CustomModal/CustomModal"
import "./AuthDesign.scss"

const { Title, Text } = Typography

const AuthDesign = ({ authForm, formType }) => {
    const currentYear = new Date().getFullYear();
    const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
    const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);

    return (
        <div className="auth-design-container">
            <img src={SemiRing} alt="semi-ring" className="semi-ring-image" />
            <Row style={{ height: "100%" }}>
                <Col xs={0} lg={12}>
                    <div className="auth-sidebar-container">
                        <div className="content-container">
                            <div className="logo">
                                <Image preview={false} src={Logo} alt="Logo" />
                            </div>
                            <Title>{formType === "login" ? ABOUT_KARNCY.KARNCY_USERS_DESC_LOGIN : ABOUT_KARNCY.KARNCY_USERS_DESC_SIGNUP}</Title>
                            <List
                                dataSource={ABOUT_KARNCY.ABOUT_LIST_DATA}
                                size="small"
                                className="custom-list-border"
                                renderItem={(item, index) => (
                                    <List.Item key={index}>
                                        <Flex align="center" justify="flex-start" gap={10}>
                                            <Avatar src={item.icon} shape="square" style={{ width: 24, height: 24 }} />
                                            <Text>{item.title}</Text>
                                        </Flex>
                                    </List.Item>
                                )}
                            />
                        </div>
                        <Image src={CoinsFly} alt="Coins" preview={false} />
                        <Flex justify="space-between" className="copyrights-container">
                            <Text>
                                Karncy © {currentYear}, All Rights Reserved.
                            </Text>
                            <Flex justify="center" gap={10}>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setIsTermsModalOpen(true)}
                                >
                                    {GEN_TEXT.TERMS}
                                </span>
                                <span>|</span>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setIsPrivacyModalOpen(true)}
                                >
                                    {GEN_TEXT.PRIVACY}
                                </span>
                            </Flex>
                            <CustomModal
                                open={isTermsModalOpen}
                                centered
                                width="70%"
                                onCancel={() => setIsTermsModalOpen(false)}
                                content={
                                    <iframe
                                        title="Terms and Conditions"
                                        src={TermsPdf}
                                        width="100%"
                                        height="500px"
                                        style={{ border: "none" }}
                                    />
                                }
                            />

                            <CustomModal
                                open={isPrivacyModalOpen}
                                centered
                                width="70%"
                                onCancel={() => setIsPrivacyModalOpen(false)}
                                content={
                                    <iframe
                                        title="Privacy Policy"
                                        src={PrivacyPdf}
                                        width="100%"
                                        height="500px"
                                        style={{ border: "none" }}
                                    />
                                }
                            />
                        </Flex>
                    </div>
                </Col>
                <Col xs={24} lg={12}>
                    <div className="auth-form-container">
                        {authForm}
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default AuthDesign
